//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "SystemMaintenance",
    data() {
        return {
            lang: '',
            text: '',
        }
    },
    created() {
        this.$http.get('/v1/api/ad/startpage/notice').then(res => {
            if(res.data.header.resultCode === 0){
                this.text = res.data.body
            }
        })
        this.lang = window.localStorage.lang
    }
}



// WEBPACK FOOTER //
// ./src/page/SystemMaintenance.vue